<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 考勤组管理 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="考勤组名称"></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                    <el-button type="danger"  class="handle-del mr10" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
                    <!-- <el-button type="danger"  @click="setCopy()">复制</el-button> -->
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="350"
                border
                default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" ></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="名称" width="80"></el-table-column>
                <el-table-column prop="" label="人数" width="80">
                      <template slot-scope="scope">
                        <div v-if="scope.row.partakeAttendant !=''">
                           {{scope.row.partakeAttendant.split(',').length}}人
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template> 
                </el-table-column>
                <el-table-column prop="type" label="类型" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 1">
                           固定班制
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workDates" label="考勤时间"  :show-overflow-tooltip="true" width="450">
                    <template slot-scope="scope">
                        <div v-html="scope.row.workDates"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                     <template slot-scope="scope">
                        <div v-if="scope.row.status == 1">
                           开启
                        </div>
                        <div v-else-if="scope.row.status == 2" style="color:red;">
                           停用
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small" style="color: #387EE8;">
                            修改规则
                        </el-button>
                        <el-button  v-if="scope.row.status == 2"
                            @click.native.prevent="setStatus(scope.row,1)"
                            type="text"
                            size="small" style="color: #387EE8;">
                            启用
                        </el-button>
                        <el-button  v-if="scope.row.status == 1"
                            @click.native.prevent="setStatus(scope.row,2)"
                            type="text"
                            size="small" style="color: red" >
                            停用
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!-- <div v-if="setCopyVisible">
            <setCopy ref="setCopy"></setCopy>
        </div> -->
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import add from './Add.vue';
    import update from './Update.vue';
    // import setCopy from './SetCopy.vue';

    export default {
        name:"Group",
        data(){
            return{
                menuName:"",
                addVisible:false,
                updateVisible:false,
                // setCopyVisible:false,

                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    name:"",
                    deptId:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[]
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.listAttendaceGroupUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.form.name,
                    deptId:this.form.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //修改界面
            setUpdate(val){
                this.updateVisible=true;
                this.$nextTick(() => {

                    let url  = this.listWorkDateUrl;
                    let data = {
                        attendaceGroupId:val.id
                    };
                    this.apiPost(url,data).then((res) => {
                        if(res.status==200){
                            let workDates=res.data.list;
                            this.$refs['update'].init(val,workDates);
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    },(err)=>{
                        console.log(err);
                    });

                })
            },
            // 启用/停用
            setStatus(row,status){
                this.form.id = row.id;
                this.form.status=status;
                if(status == 1){
                    let msg="";
                    if(row.partakeAttendant == ''){
                        msg="当前无人员参与考勤，请继续添加考勤人员";
                    }else{
                        msg="当前参与考勤人员为【"+(row.partakeAttendant.split(',').length)+"】人，请核实考勤人员";
                    }
                    this.$commonFn.showTipConfirm(msg,this.updateStatusSuccess);
                }else if(status == 2){
                    let msg="此操作将考勤组停用，导致属于该考勤组教职无法考勤，是否继续？";
                    this.$commonFn.showConfirm2(msg,this.updateStatusSuccess);
                }
            },
            updateStatusSuccess(){
                let url  = this.attendaceGroupUpdateStatusUrl;
                let data = {
                    id:this.form.id,
                    status:this.form.status
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.attendaceGroupRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除管理员
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            }, 
            // setCopy(){ // 复制对象
            //     this.setCopyVisible=true;
            //     this.$nextTick(() => {
            //         this.$refs['setCopy'].init(this.form.deptId);
            //     })
            // },
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/attendance/group/Group.vue